function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import eventFiltering from "../../utils/eventFiltering";
export default {
  props: {
    spec: {
      type: Object,
      required: true
    },
    type: {
      type: String,
      required: true
    }
  },
  data: function data() {
    return {
      variant: {},
      rules: [],
      fields: {
        email: {
          type: "email",
          prependIcon: "email",
          onRightIconClick: function onRightIconClick() {},
          rules: [function (v) {
            return !v || /^\w+([.-\\+]?\w+)*@\w+([.-]?\w+)*(\.\w{2,5})+$/.test(v) || "E-mail must be valid";
          }]
        },
        number: {
          type: "number",
          prependIcon: "looks_one",
          onRightIconClick: function onRightIconClick() {},
          rules: [function (v) {
            return !v || /^\-?[.\d]*$/.test(v) || "Must be a number";
          }]
        },
        password: {
          type: "password",
          prependIcon: "lock",
          appendIcon: "visibility",
          onRightIconClick: function onRightIconClick(vm) {
            vm.togglePasswordVisibility();
          },
          rules: [function (v) {
            return !v || v.length >= 6 || "Password must be longer";
          }]
        },
        url: {
          type: "url",
          prependIcon: "web",
          onRightIconClick: function onRightIconClick() {},
          rules: [// From https://gist.github.com/rodneyrehm/8013067
          // Make sure to support unicode chars, e.g. https://www.facebook.com/%E5%86%B0%E5%8F%8B%E4%BE%86%E7%9C%8B%E7%90%83-103474391161721/
          function (v) {
            return !v || /^(https?|ftp|torrent|image|irc):\/\/(-\.)?([^\s\/?\.#]+\.?)+(\/[^\s]*)?$/i.test(v) || "Must be a valid URL";
          }]
        },
        search: {
          type: "url",
          prependIcon: "search",
          onRightIconClick: function onRightIconClick() {},
          rules: [function (v) {
            return !v || /^\w+:\/\/[.-\w]+$/.test(v) || "Must be a valid URL";
          }]
        }
      }
    };
  },
  computed: {
    leftIconName: function leftIconName() {
      var icon = this.spec.leftIcon || {};
      var materialIcon = icon.material || {};
      return materialIcon.name;
    }
  },
  methods: {
    $ready: function $ready() {
      this.variant = this.fields[this.type] || {};
      this.rules = this.$validation(this.variant.rules);
    },
    togglePasswordVisibility: function togglePasswordVisibility() {
      var passwordField = this.fields["password"];

      if (passwordField.appendIcon == "visibility") {
        passwordField.type = "text";
        passwordField.appendIcon = "visibility_off";
      } else {
        passwordField.type = "password";
        passwordField.appendIcon = "visibility";
      }
    },
    onRightIconClick: function onRightIconClick() {
      this.variant.onRightIconClick(this);
    },
    classes: function classes() {
      return this.$classes().concat("g-text-field--hintless");
    },
    onChange: eventFiltering.debounce(function () {
      this.executeActionWithParams();
    }, 300),
    executeActionWithParams: function executeActionWithParams() {
      var _this = this;

      Utils.type.ifObject(this.spec.onChange, function (onChange) {
        _this.$nextTick(function () {
          var params = _defineProperty({}, _this.spec.paramNameForFormData || "formData", _defineProperty({}, _this.fieldName, _this.fieldModel));

          var data = Object.assign({}, onChange, params);
          GLib.action.execute(data, _this);
        });
      });
    }
  }
};